import React, { useState, useEffect } from "react";
import { NavLink, Link } from "utilities/router";
import { useAuth } from "utilities/auth";

function Header({ isLoggedIn }) {
  const auth = useAuth();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 250);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const sectionLinks = [
    // { to: "/", label: "Product" }
  ];
  const publicLinks = [
    { to: "/contact", label: "Get in Touch" },
  ];

  return (
    <header
      className={`sticky top-0 z-50 w-full px-6 md:px-12 py-4 flex items-center justify-between font-jakarta text-foreground bg-background transition-all duration-300 ${
        isScrolled ? "border-b border-border shadow" : ""
      }`}
    >
      {/* Logo */}
      <NavLink
        to="/"
        className="text-xl font-bold tracking-tight text-foreground flex items-center"
      >
        Sound<span className="ml-1">Commerce</span>
        <span className="text-brand">.</span>
      </NavLink>

      {/* Navigation */}
      <nav className="hidden md:flex items-center space-x-2 ml-8">
        {[...sectionLinks, ...publicLinks].map((link, index) => (
          <Link
            to={link.to}
            key={index}
            className="text-sm px-3 py-2 font-medium text-muted-foreground hover:text-foreground hover:bg-card rounded-xl transition"
          >
            {link.label}
          </Link>
        ))}
      </nav>

      {/* Auth Actions */}
      <div className="ml-auto flex items-center space-x-2">
        {!isLoggedIn && auth.user && (
          <Link
            to="/dashboard"
            className="text-sm px-4 py-2 font-medium text-muted-foreground hover:text-foreground hover:bg-card rounded-xl transition"
          >
            My Account
          </Link>
        )}

        {auth.user ? (
          <Link
            to="/auth/signout"
            onClick={(e) => {
              e.preventDefault();
              auth.signout();
            }}
            className="px-5 py-2.5 text-sm font-medium text-foreground bg-card hover:bg-muted rounded-xl focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-white transition"
          >
            Log Out
          </Link>
        ) : (
          <>
            <Link
              to="/auth/signin"
              className="text-sm px-4 py-2 font-medium text-muted-foreground hover:text-foreground hover:bg-card rounded-xl transition"
            >
              Client Login
            </Link>
            <Link
              to="/auth/signup"
              className={`ml-1 text-sm font-medium px-5 py-2.5 rounded-xl transition focus:outline focus:outline-2 focus:outline-offset-2 ${
                isScrolled
                  ? "bg-brand text-black hover:bg-brand-400 focus:outline-white"
                  : "border border-border bg-card text-foreground hover:bg-muted focus:outline-brand"
              }`}
            >
              Register
            </Link>
          </>
        )}
      </div>
    </header>
  );
}

export default Header;
